export default __webpack_public_path__ + "static/media/gallery8.ea106754.jpg";